/**
 * Constants for aggregator iframe functionality
 * These constants are specific to the aggregator feature and should not affect normal app behavior
 */

// Polling configuration
export const AGGREGATOR_POLLING_INTERVAL = 8000; // 8 seconds in milliseconds
export const AGGREGATOR_MAX_POLLING_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds

// Aggregator status strings (as returned from backend)
export const AGGREGATOR_STATUS = {
  LENDER_RESPONSE: {
    APPROVED: 'approved',
    PRE_APPROVED: 'Pre Approved',
    DECLINED: 'declined',
    PENDING: 'pending',
  },
  SUBMISSION_STATE: {
    PENDING: 'pending',
    PROCESSING: 'processing',
    COMPLETED: 'completed',
    FAILED: 'failed',
    LENDER_RESPONDED: 'Lender Responded',
  },
} as const;

// PostMessage event types for iframe communication
export const AGGREGATOR_POST_MESSAGE_TYPES = {
  DISCLOSURES_ACCEPTED: 'FORMPIPER_DISCLOSURES_ACCEPTED',
  UPDATE_IFRAME: 'FORMPIPER_UPDATE_IFRAME',
} as const;

// Error messages
export const AGGREGATOR_ERROR_MESSAGES = {
  MISSING_TOKEN: 'Missing token parameter. Please check the URL.',
  TOKEN_EXPIRED: 'Your token has expired or is invalid. Please contact support.',
  NOT_FOUND: 'Application status not found.',
  GENERIC_ERROR: 'An error occurred while loading application status. Please try again later.',
  UNABLE_TO_LOAD: 'Unable to load application status.',
  NO_DISCLOSURES: 'No disclosures available for this application.',
  DISCLOSURES_NOT_FOUND: 'Disclosures not found for this application.',
} as const;
